// extracted by mini-css-extract-plugin
export default {"h2":"EventsList_h2__aT857","events":"EventsList_events__2opgW"};